import type { WalletAdapter } from '../types'
type Eip1193Provider = { request: (args: { method: string; params?: unknown[] }) => Promise<unknown> }
declare global { interface Window { ethereum?: Eip1193Provider & { providers?: (Eip1193Provider & { isMetaMask?: boolean; isCoinbaseWallet?: boolean })[]; isMetaMask?: boolean; isCoinbaseWallet?: boolean } } }
/** EIP-1193 adapter. Only addresses returned by the wallet are reported as connected. */
export const injectedAdapter: WalletAdapter = {
 async connect(wallet) {
  const candidates = window.ethereum?.providers ?? (window.ethereum ? [window.ethereum] : [])
  const provider = wallet.id === 'coinbase'
    ? candidates.find((item) => item.isCoinbaseWallet)
    : wallet.id === 'metamask'
      ? candidates.find((item) => item.isMetaMask)
      : undefined
  if (!provider) throw new Error(`${wallet.name} was not detected. Install or unlock it, then retry.`)
  const accounts = await provider.request({method:'eth_requestAccounts'})
  if (!Array.isArray(accounts) || typeof accounts[0] !== 'string') throw new Error('The wallet did not return an account.')
  const chain = await provider.request({method:'eth_chainId'}).catch(() => undefined)
  return {address:accounts[0],chainId:typeof chain === 'string' ? chain : undefined}
 }
}
export const defaultAdapters = { injected: injectedAdapter }
